import type { AppState } from '@store/types'
import { useSelector } from 'react-redux'

import type { StickyNote } from '@/types'
import { getBlockContentText } from '@/utils'

const useNotes = () =>
  useSelector((state: AppState) => {
    const { stickyNotes } = state.manager.project

    return stickyNotes.map((note) => ({
      id: note.id,
      content: getBlockContentText(note.content),
      color: note.color,
      offset: note.offset,
      size: note.size,
    })) as StickyNote[]
  })

export default useNotes
